import { Observable } from "rxjs";
import { combineEpics } from "redux-observable";

import st from "lib/utils/index";
import { ReviewDecorator } from "lib/decorators/index";
import { ReviewsRepository } from "lib/repositories/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "reviews/ReviewsListView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "reviews/ReviewsListView/DESTROY_VIEW";
export const LOAD_RECORDS = "reviews/ReviewsListView/LOAD_RECORDS";
export const FETCH_RECORDS = "reviews/ReviewsListView/FETCH_RECORDS";
export const FETCH_RECORDS_START = "reviews/ReviewsListView/FETCH_RECORDS_START";
export const FETCH_RECORDS_SUCCESS = "reviews/ReviewsListView/FETCH_RECORDS_SUCCESS";
export const FETCH_RECORDS_FAILURE = "reviews/ReviewsListView/FETCH_RECORDS_FAILURE";
export const CHANGE_PAGINATION = "reviews/ReviewsListView/CHANGE_PAGINATION";
export const SET_PAGINATION = "reviews/ReviewsListView/SET_PAGINATION";

export const stateSelector = (state) => state.reviews.ReviewsListView;

const recordsResource = createResourceInstance({
  LOAD: LOAD_RECORDS,
  FETCH: FETCH_RECORDS,
  FETCH_START: FETCH_RECORDS_START,
  FETCH_SUCCESS: FETCH_RECORDS_SUCCESS,
  FETCH_FAILURE: FETCH_RECORDS_FAILURE,
  stateSelector,
  stateKey: "allRecords",
  getModel: ({ offset, limit }) => {
    const page = offset / limit + 1;
    return ReviewsRepository.findAll({ page, per: limit });
  },
});

const limit = parseInt(localStorage.getItem("reviewsLimit"), 10) || 10;

const initialState = {
  allRecords: recordsResource.initialState,
  offset: 0,
  limit: limit,
};

const reducers = {
  ...recordsResource.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,

  [SET_PAGINATION]: (state, { offset = state.offset, limit = state.limit }) => ({
    ...state,
    offset,
    limit,
  }),
};

const viewEpics = [
  ...recordsResource.epics,

  (actions$) => Observable.of(fetchRecords()),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).map(({ offset, limit }) => setPagination({ offset, limit })),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).debounceTime(300).mapTo(fetchRecords()),
];

const epics = [
  (actions$, store) =>
    actions$
      .ofType(INITIALIZE_VIEW)
      .concatMap(() => combineEpics(...viewEpics)(actions$, store).takeUntil(actions$.ofType(DESTROY_VIEW))),
];

export const { load: loadRecords, fetch: fetchRecords } = recordsResource.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export function destroyView() {
  return { type: DESTROY_VIEW };
}

export function changePagination({ offset, limit }) {
  return { type: CHANGE_PAGINATION, offset, limit };
}

export function setPagination({ offset, limit }) {
  return { type: SET_PAGINATION, offset, limit };
}

export function setParamsWithLocationQuery({ o = initialState.offset, l = initialState.limit, ...query } = {}) {
  return (dispatch) => {
    dispatch(setPagination({ offset: +o, limit: +l }));
  };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/reviews/ReviewsListView/index.js